'use strict';

module.exports = function (ngModule) {
    ngModule.config(require('./live'))
}


/** WEBPACK FOOTER **
 ** ./src/landing/routes/index.js
 **/